import { useEffect, useState } from "react";
import { IconLookup, IconName, library } from "@fortawesome/fontawesome-svg-core";

export const useFontAwesomeIconPack = () => {
    const [iconPack, setIconPack] = useState<IconLookup[]>([]);

    useEffect(() => {
        if (iconPack.length < 1) {
            import("@fortawesome/free-solid-svg-icons").then((module) => {
                // Delete problematic icons
                const fas = { ...module.fas };
                delete fas.faCookie;
                delete fas.faFontAwesomeLogoFull;
                console.log(Object.keys(fas).length);

                const icons = Object.values(fas).map((icon) => ({
                    prefix: icon.prefix,
                    icon: icon.icon,
                    iconName: icon.iconName as IconName
                }));

                const uniqueIcons = removeDuplicatesByProperty(icons, "iconName");

                library.add(...uniqueIcons);
                setIconPack((prev) => [...prev, ...uniqueIcons]);
            });

            import("@fortawesome/free-regular-svg-icons").then((module) => {
                // Delete problematic icons
                const far = { ...module.far };
                delete far.faCookie;
                delete far.faFontAwesomeLogoFull;
                console.log(Object.keys(far).length);

                const icons = Object.values(far).map((icon) => ({
                    prefix: icon.prefix,
                    icon: icon.icon,
                    iconName: icon.iconName as IconName
                }));

                const uniqueIcons = removeDuplicatesByProperty(icons, "iconName");

                library.add(...uniqueIcons);
                setIconPack((prev) => [...prev, ...uniqueIcons]);
            });
        }
    }, []);

    return iconPack;
};

function removeDuplicatesByProperty(arr: any[], property: string) {
    const uniqueMap = new Map();
    const result = [];

    for (const item of arr) {
        if (!uniqueMap.has(item[property])) {
            uniqueMap.set(item[property], true);
            result.push(item);
        }
    }

    return result;
}
